<template>
     <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="card-body">
                        <router-link  to="/class-xi-admission"><i class="fa fa-arrow-left"></i> Go back</router-link>
                        <h5 class="text-monospace font-weight-bolder mt-2">
                            Student Information
                        </h5>
                        <hr>
                         <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Name of Student:</label>
                            <div class="col-sm-10">
                                    {{name}}
                            </div>
                        </div>
                         <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Index Number:</label>
                            <div class="col-sm-10">
                                 {{index_number}}
                            </div>
                        </div>
                         <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Dzongkhag:</label>
                            <div class="col-sm-10">
                                    {{dzongkhag}}
                            </div>
                        </div>
                         <div class="form-group row">
                            <label class="col-sm-2 col-form-label">School:</label>
                            <div class="col-sm-10">
                                    {{school}}
                            </div>
                        </div>
                        <h5 class="text-monospace font-weight-bolder">
                            Student Information
                        </h5>
                        <hr>
                         <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Dzongkhag: <span class="text-danger">*</span></label>
                            <div class="col-sm-10">
                                <select v-model="form.dzongkhag_id" class="form-control" aria-label="dzongkhag_id" :class="{ 'is-invalid': is_dzo_invalid }" id="dzongkhag_id" @change="getPublicOrganization">
                                    <option v-for="(item, i) in dzongkhags" :key="i" :value="item.id">{{item.name}}</option>
                                </select>
                                <span v-if="is_dzo_invalid">{{error}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-2 col-form-label">School: <span class="text-danger">*</span> </label>
                            <div class="col-sm-10">
                                <select v-model="form.school_id" class="form-control" aria-label="school_id" :class="{ 'is-invalid': is_school_invalid }" id="school_id" @change="remove_err('school_id')">
                                    <option v-for="(item, i) in schools" :key="i" :value="item.id">{{item.organization}}</option>
                                </select>
                                <span v-if="is_school_invalid">{{error}}</span>
                            </div>
                        </div>
                        <div class="form-group row">   
                            <label class="col-sm-2 col-form-label">Stream: <span class="text-danger">*</span> </label>
                            <div class="col-sm-10">
                                <select v-model="form.stream" class="form-control" aria-label="stream"  :class="{ 'is-invalid': is_stream_invalid }" id="stream" @change="remove_err('stream')">
                                    <option v-for="(item3, i2) in streams" :key="i2" :value="item3.id">{{item3.name}}</option>
                                </select>
                                <span v-if="is_school_invalid">{{error}}</span>
                            </div>
                        </div>
                        <div class="card-footer text-right">
                             <button type="button" class="btn btn-sm btn-primary" @click="update"> <i class="fa fa-user-check"></i> Admit </button> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            
            name:'',
            index_number:'',
            dzongkhag:'',
            school:'',
            dzongkhags:[],
            schools:[],
        
            user_type:'',
            streams: [
                {name:'Science',id:'Science'},
                {name:'Arts',id:'Arts'},
                {name:'Commerce',id:'Commerce'},
                {name:'Rigzhung',id:'Rigzhung'},
            ],
             form: new form({
                id:'',
                dzongkhag_id:'',
                school_id:'',
                stream:'',
             }),
            admission_details:[],
            is_dzo_invalid:false,
            is_school_invalid:false,
            is_stream_invalid:false,
            error:''
        }
    },
    methods:{
        remove_err(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
                this.showTable=true;
            }else{
                this.is_invalid = true;
                this.error = "This field is required"
            }
        },
        getDzongkhags(){
                axios.get('dzongkhags/getDzongkhags')
                .then(response =>{ this.dzongkhags = response.data })
                .catch(error => console.log(error));
        },
        getPublicOrganization(){
            this.schools = [];
            axios.get('school/getPublicOrganization/'+this.form.dzongkhag_id)
            .then(response =>{ this.schools = response.data })
            .catch(error => console.log(error));
            
        }, 
        update(){
            axios.post('admissions/updateAdmittedStudents',this.form).then(res => {
                 if(res.data.error){
                    Swal.fire({
                        icon: 'warning',
                        text: res.data.error,
                    })
                 }else{
                    Toast.fire({
                        icon: 'success',
                        title: 'Detail Updated successfully'
                    })
                this.$router.push({name:'class-xi-admission'})
                }
            }).catch(error => console.log(error))
        },
    },
    mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
        })
        this.getDzongkhags()
        this.getPublicOrganization()
    },
    created(){
        this.name=this.$route.params.data.name;
        this.index_number = this.$route.params.data.std_indexno;
        this.dzongkhag=this.$route.params.data.dzongkhag;
        this.school =this.$route.params.data.organization;
        this.form.dzongkhag_id=this.$route.params.data.class_xi_dzongkhag_id;
        this.form.school_id=this.$route.params.data.class_xi_school_id;
        this.form.stream=this.$route.params.data.stream;
        this.form.id=this.$route.params.data.id;
    }
    
}
</script>